import classnames from 'classnames'

import Button from '@components/Button'
import { CardSection } from '@components/CardSection'

import {
    PURCHASE_FLOW,
    FLOW_STEP_VEHICLE,
    FLOW_STEP_ACCESS_OPTIONS,
    FLOW_STEP_DELIVERY,
} from 'subscription-flow/constants'
import purchaseStyles from 'subscription-flow/styles.module.scss'

import styles from './styles.module.scss'

const PurchaseFlowHeader = ({
    activeStep,
    stepValues,
    location,
    translate: t,
    onStepClick,
    flowSteps = PURCHASE_FLOW,
}) => {
    const isAccessOptionStep = step => (step === FLOW_STEP_ACCESS_OPTIONS ? FLOW_STEP_DELIVERY : step)
    const stepValueLabel = step =>
        step === FLOW_STEP_VEHICLE ? stepValues[step]['0'].tag : stepValues[step].displayValue

    return (
        <CardSection className={purchaseStyles.progressSection} loading={false}>
            <div className={classnames('d-flex', 'justify-content-between', 'align-items-start')}>
                <span className={classnames(purchaseStyles.location, 'd-flex', 'text-large')}>{location}</span>
                <Button
                    btnStyle="link"
                    size="small"
                    onClick={() => window.location.href('/')}
                    className={styles.cardSectionButton}>
                    <Link to="/">
                        <T>subscription.purchase.label.back.home</T>
                    </Link>
                </Button>
            </div>
            <div className="d-flex">
                {flowSteps.map((step, index) => (
                    <div
                        key={index}
                        role="button"
                        className={classnames(styles.progressStep, {
                            [styles.active]: activeStep === step,
                            [styles.disabled]: index > flowSteps.indexOf(activeStep),
                            [styles.passed]: index < flowSteps.indexOf(activeStep),
                        })}
                        onClick={() => index < flowSteps.indexOf(activeStep) && onStepClick(step)}>
                        <div className={styles.stepDescription}>
                            <span className={classnames(styles.stepNumber, 'text-extra-small')}>{index + 1}</span>
                            <span className={classnames(styles.stepName, 'text-large')}>
                                {t(`subscription.purchase.${step}`)}
                            </span>
                        </div>
                        {stepValues && stepValues[isAccessOptionStep(step)] && (
                            <div className={classnames('mb-3', styles.stepValue, 'text-small')}>
                                {stepValueLabel(isAccessOptionStep(step))}
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </CardSection>
    )
}

export default withTranslate(PurchaseFlowHeader)
